// ─── REGIONS ─────────────────────────────────────────────────────────────────
const S5_REGIONS = {
  us: { flag: '🇺🇸', label: 'United States' },
  uk: { flag: '🇬🇧', label: 'United Kingdom' },
  ca: { flag: '🇨🇦', label: 'Canada'         },
  au: { flag: '🇦🇺', label: 'Australia'       },
};

// ─── DATA ─────────────────────────────────────────────────────────────────────
const S5_DATA = {
  slipshort: {
    tableTitle: 'Shorts',
    headers: ['Measurement', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'],
    rows: {
      'Waist': [
        { in: '25–26.5',   cm: '63.5–67'      },
        { in: '27–28',     cm: '68.5–71'      },
        { in: '28.5–30.5', cm: '72.5–77.5'   },
        { in: '31–32',     cm: '78.5–81.5'   },
        { in: '32.5–34.5', cm: '82.5–87.5'   },
        { in: '35–37',     cm: '89–94'        },
        { in: '37.5–39.5', cm: '95–100.5'    },
        { in: '40–41.5',   cm: '101.5–105.5' },
      ],
      'Hips': [
        { in: '34.5–36.5', cm: '87.5–92.5'   },
        { in: '37–38',     cm: '94–96.5'     },
        { in: '38.5–40',   cm: '98–101.5'    },
        { in: '40.5–42',   cm: '103–106.5'   },
        { in: '42.5–44.5', cm: '108–113'     },
        { in: '45–47',     cm: '114.5–119.5' },
        { in: '47–49',     cm: '119.5–124.5' },
        { in: '50–51.5',   cm: '127–130.5'   },
      ],
    },
    sizingRow: {
      us: ['0–2',  '4–6',   '8–10',  '10–12', '14–16', '16–18', '20–22', '22–24'],
      uk: ['4–6',  '8–10',  '12–14', '14–16', '18–20', '20–22', '24–26', '26–28'],
      ca: ['0–2',  '4–6',   '8–10',  '10–12', '14–16', '16–18', '20–22', '22–24'],
      au: ['4–6',  '8–10',  '12–14', '14–16', '18–20', '20–22', '24–26', '26–28'],
    },
    sizeLabel: 'Size',
    note: 'Waist = narrowest point. Hips = fullest part. Between sizes? Size up for maximum comfort.',
    tip: 'Between sizes? We recommend sizing up for maximum comfort. Waist measurement takes priority for this style.',
  },

  bra: {
    tableTitle: 'Bras',
    headers: ['Measurement', 'XS', 'S', 'M', 'L', 'XL', 'XXL'],
    rows: {
      'Bust': [
        { in: '31–33',   cm: '78.5–84'   },
        { in: '33–35',   cm: '84–89'     },
        { in: '35–37',   cm: '89–94'     },
        { in: '37–39.5', cm: '94–100.5'  },
        { in: '40–43',   cm: '101.5–109' },
        { in: '43–46',   cm: '109–117'   },
      ],
      'Underbust': [
        { in: '25–27', cm: '63.5–68.5' },
        { in: '27–29', cm: '68.5–73.5' },
        { in: '29–31', cm: '73.5–78.5' },
        { in: '31–34', cm: '78.5–86.5' },
        { in: '34–37', cm: '86.5–94'   },
        { in: '37–40', cm: '94–101.5'  },
      ],
    },
    sizingRow: {
      us: ['0–2',  '4–6',   '8–10',  '12–14', '16–18', '20–22'],
      uk: ['4–6',  '8–10',  '12–14', '16–18', '20–22', '24–26'],
      ca: ['0–2',  '4–6',   '8–10',  '12–14', '16–18', '20–22'],
      au: ['6–8',  '10–12', '12–14', '16–18', '20–22', '24–26'],
    },
    sizeLabel: 'Size',
    note: 'If you\'re between sizes, go one size up. If you have larger breasts or prefer a looser fit, choose the bigger size.',

    howToMeasure: {
      measureTable: {
        subtitle: 'Measure snugly around your ribs right under your bust to find your Band Size. Then measure around the fullest part of your bust and subtract your underbust — the difference gives your Cup Size.',
        rows: [
          { underbust: { in: '25"–27"', cm: '63.5–68.5' }, band: { us: '30', uk: '30', ca: '30', au: '8'  } },
          { underbust: { in: '27"–29"', cm: '68.5–73.5' }, band: { us: '32', uk: '32', ca: '32', au: '10' } },
          { underbust: { in: '29"–31"', cm: '73.5–78.5' }, band: { us: '34', uk: '34', ca: '34', au: '12' } },
          { underbust: { in: '31"–33"', cm: '78.5–84'   }, band: { us: '36', uk: '36', ca: '36', au: '14' } },
          { underbust: { in: '33"–35"', cm: '84–89'     }, band: { us: '38', uk: '38', ca: '38', au: '16' } },
          { underbust: { in: '35"–37"', cm: '89–94'     }, band: { us: '40', uk: '40', ca: '40', au: '18' } },
          { underbust: { in: '37"–39"', cm: '94–99'     }, band: { us: '42', uk: '42', ca: '42', au: '20' } },
          { underbust: { in: '39"–41"', cm: '99–104'    }, band: { us: '44', uk: '44', ca: '44', au: '22' } },
        ],
      },
      cupTable: {
        rows: [
          { diff: { in: '3.5"–4.5"', cm: '9–11.5'  }, cup: { us: 'A',      uk: 'A',  ca: 'A',      au: 'A'  } },
          { diff: { in: '4.5"–5.5"', cm: '11.5–14' }, cup: { us: 'B',      uk: 'B',  ca: 'B',      au: 'B'  } },
          { diff: { in: '5.5"–6.5"', cm: '14–16.5' }, cup: { us: 'C',      uk: 'C',  ca: 'C',      au: 'C'  } },
          { diff: { in: '6.5"–7.5"', cm: '16.5–19' }, cup: { us: 'D',      uk: 'D',  ca: 'D',      au: 'D'  } },
          { diff: { in: '7.5"–8.5"', cm: '19–21.5' }, cup: { us: 'DD (E)', uk: 'DD', ca: 'DD (E)', au: 'DD' } },
        ],
      },
      fitTable: {
        subtitle: 'Once you know your Band and Cup size, match them here to find your size:',
        rows: [
          { size: 'XS',  fit: { us: '30A, 30B, 32A',           uk: '30A, 30B, 32A',           ca: '30A, 30B, 32A',           au: '8A, 8B, 10A'         } },
          { size: 'S',   fit: { us: '32B, 32C, 34A, 34B',      uk: '32B, 32C, 34A, 34B',      ca: '32B, 32C, 34A, 34B',      au: '10B, 10C, 12A, 12B'  } },
          { size: 'M',   fit: { us: '34C, 34D, 36A, 36B',      uk: '34C, 34D, 36A, 36B',      ca: '34C, 34D, 36A, 36B',      au: '12C, 12D, 14A, 14B'  } },
          { size: 'L',   fit: { us: '36C, 36D, 38A, 38B',      uk: '36C, 36D, 38A, 38B',      ca: '36C, 36D, 38A, 38B',      au: '14C, 14D, 16A, 16B'  } },
          { size: 'XL',  fit: { us: '38C, 38D, 40A, 40B',      uk: '38C, 38D, 40A, 40B',      ca: '38C, 38D, 40A, 40B',      au: '16C, 16D, 18A, 18B'  } },
          { size: '2XL', fit: { us: '40C, 40D, 42A, 42B',      uk: '40C, 40D, 42A, 42B',      ca: '40C, 40D, 42A, 42B',      au: '18C, 18D, 20A, 20B'  } },
          { size: '3XL', fit: { us: '42C, 42D, 44A, 44B',      uk: '42C, 42D, 44A, 44B',      ca: '42C, 42D, 44A, 44B',      au: '20C, 20D, 22A, 22B'  } },
        ],
      },
    },
  },
};

// ─── STATE ────────────────────────────────────────────────────────────────────
let s5State = {
  open:   false,
  region: 'us',
  tab:    'slipshort',
  metric: true,
};

// ─── HELPERS ──────────────────────────────────────────────────────────────────
async function s5AnimateCells(fn) {
  const cells = document.querySelectorAll('.s5-cell-val');
  cells.forEach(c => {
    c.classList.remove('s5-fade-in');
    c.classList.add('s5-fade-out');
  });
  await new Promise(r => setTimeout(r, 200));
  fn();
  document.querySelectorAll('.s5-cell-val').forEach(c => {
    c.classList.remove('s5-fade-out');
    c.classList.add('s5-fade-in');
  });
}

// ─── RENDER ───────────────────────────────────────────────────────────────────
function s5RenderMainTable() {
  const { tab, region, metric } = s5State;
  const data                    = S5_DATA[tab];
  const thead                   = document.getElementById('s5-mainThead');
  const tbody                   = document.getElementById('s5-mainTbody');
  const howToMeasureSection     = document.getElementById('s5-howToMeasure');
  const subSection              = document.getElementById('s5-subSection');
  const fitNote                 = document.getElementById('s5-fitNote');

  if (!thead || !tbody) return;

  // ── Table title
  const titleEl = document.getElementById('s5-tableTitle');
  if (titleEl) titleEl.textContent = data.tableTitle || '';

  // ── Unit toggle row: visible for shorts, hidden for bra (moves into howToMeasure)
  const unitRow = document.getElementById('s5-unitToggle')?.closest('.s5-unit-row');
  if (unitRow) unitRow.style.display = tab === 'bra' ? 'none' : '';

  // ── Main table wrap: visible for shorts, hidden for bra
  const tableSection = thead.closest('.s5-table-section');
  const tableWrap    = tableSection?.querySelector('.s5-size-table-wrap');
  if (tableWrap) tableWrap.style.display = tab === 'bra' ? 'none' : '';

  // ── Build table rows
  const cols = data.headers.slice(1);
  thead.innerHTML = `<tr>
    <th>${data.sizeLabel || 'Size'}</th>
    ${cols.map(c => `<th>${c}</th>`).join('')}
  </tr>`;

  let rows = '';

  if (tab === 'slipshort') {
    const sizeRow     = data.sizingRow[region] || data.sizingRow['us'];
    const regionLabel = S5_REGIONS[region]?.label ?? region.toUpperCase();
    rows += `<tr>
      <td>${regionLabel} Size</td>
      ${sizeRow.map(v => `<td><span class="s5-cell-val">${v}</span></td>`).join('')}
    </tr>`;
    for (const [label, vals] of Object.entries(data.rows)) {
      const unit       = metric ? 'in' : 'cm';
      const unitSuffix = metric ? ' (in)' : ' (cm)';
      rows += `<tr>
        <td>${label}${unitSuffix}</td>
        ${vals.map(v => `<td><span class="s5-cell-val">${v[unit]}</span></td>`).join('')}
      </tr>`;
    }
  }

  tbody.innerHTML = rows;

  // ── Sub section (howToMeasure or tip)
  if (data.howToMeasure) {
    howToMeasureSection.innerHTML = s5RenderHowToMeasure(data.howToMeasure, metric, region);
    subSection.innerHTML = '';
    // Re-bind the injected toggle after innerHTML set
    s5BindHtmToggle();
  } else if (data.tip) {
    howToMeasureSection.innerHTML = '';
    subSection.innerHTML = `<div class="s5-sizing-tip">${data.tip}</div>`;
  } else {
    howToMeasureSection.innerHTML = '';
    subSection.innerHTML = '';
  }

  fitNote.textContent = data.note || '';
}

// ─── HOW TO MEASURE (Bra) ────────────────────────────────────────────────────
function s5RenderHowToMeasure(htmData, metric, region) {
  const unit      = metric ? 'in' : 'cm';
  const unitLabel = metric ? 'in' : 'cm';
  const reg       = region || 'us';
  const isMetric  = metric;

  const { measureTable, cupTable, fitTable } = htmData;

  const bandColLabel = reg === 'au' ? 'AU / NZ Band' : 'Band Size';
  const cupColLabel  = 'Cup Size';

  // ── Combined measure table rows (8 band + 5 cup merged)
  const maxRows = Math.max(measureTable.rows.length, cupTable.rows.length);
  const combinedRows = Array.from({ length: maxRows }, (_, i) => {
    const bRow = measureTable.rows[i];
    const cRow = cupTable.rows[i];
    return `<tr>
      <td><span class="s5-cell-val">${bRow ? bRow.underbust[unit] : ''}</span></td>
      <td><span class="s5-cell-val">${bRow ? bRow.band[reg]       : ''}</span></td>
      <td><span class="s5-cell-val">${cRow ? cRow.diff[unit]      : ''}</span></td>
      <td><span class="s5-cell-val">${cRow ? cRow.cup[reg]        : ''}</span></td>
    </tr>`;
  }).join('');

  // ── Suggested Fit rows
  const fitRows = fitTable.rows.map(r => `
    <tr>
      <td>${r.size}</td>
      <td><span class="s5-cell-val">${r.fit[reg]}</span></td>
    </tr>`).join('');

  // ── Toggle active states
  const cmActive = !isMetric ? 'active' : '';
  const inActive = isMetric  ? 'active' : '';
  const toggleMetric = isMetric ? 'metric' : '';
  const ariaChecked  = String(isMetric);

  return `
    <div class="s5-size-table-wrap">
      <table class="s5-size-table">
        <thead>
          <tr>
            <th>Size</th>
            <th>Suggested Fit</th>
          </tr>
        </thead>
        <tbody>${fitRows}</tbody>
      </table>
    </div>

    <h3 class="s5-sub-title">How to Measure</h3>
    <p class="s5-step-subtitle">${measureTable.subtitle}</p>

    <div class="s5-unit-row">
      <span class="s5-unit-label ${cmActive}" id="s5-htmLabelCm">cm</span>
      <div class="s5-toggle-track ${toggleMetric}" id="s5-htmToggle" role="switch" aria-checked="${ariaChecked}" tabindex="0" aria-label="Toggle units">
        <div class="s5-toggle-thumb"></div>
      </div>
      <span class="s5-unit-label ${inActive}" id="s5-htmLabelIn">in</span>
    </div>

    <div class="s5-size-table-wrap">
      <table class="s5-size-table">
        <thead>
          <tr>
            <th>Under Bust (${unitLabel})</th>
            <th>${bandColLabel}</th>
            <th>Difference (${unitLabel})</th>
            <th>${cupColLabel}</th>
          </tr>
        </thead>
        <tbody>${combinedRows}</tbody>
      </table>
    </div>
  `;
}

// ─── BIND HOW-TO-MEASURE TOGGLE (re-runs after innerHTML inject) ──────────────
function s5BindHtmToggle() {
  const htmToggle  = document.getElementById('s5-htmToggle');
  const htmLabelCm = document.getElementById('s5-htmLabelCm');
  const htmLabelIn = document.getElementById('s5-htmLabelIn');
  if (!htmToggle) return;

  function applyHtmToggle() {
    const isMetric = s5State.metric;
    htmToggle.classList.toggle('metric', isMetric);
    htmToggle.setAttribute('aria-checked', String(isMetric));
    if (htmLabelCm) htmLabelCm.classList.toggle('active',  isMetric);
    if (htmLabelIn) htmLabelIn.classList.toggle('active', !isMetric);
  }

  htmToggle.addEventListener('click', async () => {
    s5State.metric = !s5State.metric;
    // sync main toggle too
    s5ApplyMainToggle();
    await s5AnimateCells(s5RenderMainTable);
  });

  htmToggle.addEventListener('keydown', async e => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      s5State.metric = !s5State.metric;
      s5ApplyMainToggle();
      await s5AnimateCells(s5RenderMainTable);
    }
  });

  applyHtmToggle();
}

// ─── OPEN / CLOSE ─────────────────────────────────────────────────────────────
function s5OpenDrawer() {
  s5State.open = true;
  document.getElementById('s5-overlay').classList.add('open');
  document.getElementById('s5-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
  s5RenderMainTable();
}

function s5CloseDrawer() {
  s5State.open = false;
  document.getElementById('s5-overlay').classList.remove('open');
  document.getElementById('s5-drawer').classList.remove('open');
  document.body.style.overflow = '';
}

// ─── INIT ─────────────────────────────────────────────────────────────────────
function s5ApplyMainToggle() {
  const toggleTrack = document.getElementById('s5-unitToggle');
  if (!toggleTrack) return;
  const isMetric = s5State.metric;
  toggleTrack.classList.toggle('metric', isMetric);
  toggleTrack.setAttribute('aria-checked', String(isMetric));
  const labelCm = document.getElementById('s5-labelCm');
  const labelIn = document.getElementById('s5-labelIn');
  if (labelCm) labelCm.classList.toggle('active',  isMetric);
  if (labelIn) labelIn.classList.toggle('active', !isMetric);
}

function s5Init() {
  const openBtn     = document.getElementById('s5-openDrawer');
  const closeBtn    = document.getElementById('s5-closeDrawer');
  const overlay     = document.getElementById('s5-overlay');
  const regionSel   = document.getElementById('s5-regionSelect');
  const toggleTrack = document.getElementById('s5-unitToggle');

  if (!closeBtn || !overlay) return;

  const activeTabBtn = document.querySelector('.s5-tab-btn.active');
  if (activeTabBtn) s5State.tab = activeTabBtn.dataset.tab;

  if (openBtn) openBtn.addEventListener('click', s5OpenDrawer);
  closeBtn.addEventListener('click', s5CloseDrawer);
  overlay.addEventListener('click', s5CloseDrawer);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && s5State.open) s5CloseDrawer();
  });

  regionSel.addEventListener('change', async e => {
    s5State.region = e.target.value;
    document.getElementById('s5-regionFlag').textContent = S5_REGIONS[s5State.region].flag;
    await s5AnimateCells(s5RenderMainTable);
  });

  document.querySelectorAll('.s5-tab-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      document.querySelectorAll('.s5-tab-btn').forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      s5State.tab = btn.dataset.tab;
      await s5AnimateCells(s5RenderMainTable);
      document.querySelector('#s5-drawer .s5-drawer-body')
        ?.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // ── Main toggle (shorts tab only — hidden on bra tab)
  if (toggleTrack) {
    toggleTrack.addEventListener('click', async () => {
      s5State.metric = !s5State.metric;
      s5ApplyMainToggle();
      await s5AnimateCells(s5RenderMainTable);
    });

    toggleTrack.addEventListener('keydown', async e => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        s5State.metric = !s5State.metric;
        s5ApplyMainToggle();
        await s5AnimateCells(s5RenderMainTable);
      }
    });
  }

  s5RenderMainTable();
  s5ApplyMainToggle();
}

// ─── BOOT ─────────────────────────────────────────────────────────────────────
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', s5Init);
} else {
  s5Init();
}